// @ts-expect-error - UserFragment is needed for the fragment spread
// eslint-disable-next-line
import { UserFragment } from "../fragments/User.fragment";
import { graphql } from "../generated";

export const GET_ME_QUERY = graphql(`
  query Me {
    me {
      ...UserFragment
    }
  }
`);
